import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    schedulers: [],
  },
  getters: {
    schedulers: state => state.schedulers,
  },
  mutations: {
    SET_SCHEDULERS: (state, schedulers) => { state.schedulers = schedulers },
  },
  actions: {
    async getSchedulersByDayAndCreditClass({ commit }, params) {
      try {
        const response = await axios.get('uni/schedules/getSchedulesByDayAndCreditClass', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          commit('SET_SCHEDULERS', data.data)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async createSchedule({ commit }, dataObj) {
      try {
        const response = await axios.post('uni/schedules/createSchedule', dataObj)
        const { data } = response
        return data
      } catch (e) {
        handleCatch(e)
      }
    },

    async updateSchedule({ commit }, dataObj) {
      try {
        const response = await axios.put('uni/schedules', dataObj)
        const { data } = response
        return data
      } catch (e) {
        handleCatch(e)
      }
    },

    async deleteSchedule({ commit }, id) {
      try {
        const response = await axios.delete(`uni/schedules/${id}`)
        const { data } = response
        return data.code === ApiCode.SUCCESS
      } catch (e) {
        handleCatch(e)
      }
    },
  },
}
